// src/hooks/useRecaptcha.ts
import { useState, useRef } from 'react'

const useRecaptcha = () => {
  const [captchaToken, setCaptchaToken] = useState<string | null>(null)
  const recaptchaRef = useRef<any>(null)
  const customCaptchaRef = useRef<any>(null)

  const handleCaptchaChange = (token: string | null) => {
    setCaptchaToken(token)
  }

  const resetCaptcha = () => {
    setCaptchaToken(null)

    // Reset Google ReCAPTCHA if it exists
    if (recaptchaRef.current) {
      recaptchaRef.current.reset()
    }

    // Reset Custom Captcha if it exists
    if (customCaptchaRef.current) {
      customCaptchaRef.current.reset()
    }
  }

  return {
    captchaToken,
    handleCaptchaChange,
    resetCaptcha,
    recaptchaRef,
    customCaptchaRef,
  }
}

export default useRecaptcha
